// frontend/src/components/WhereToBuySection.js
import React, { useEffect, useState } from 'react';
import './WhereToBuySection.css';
// Import the SVG logos directly from your assets folder
import amazonLogoSvg from '../assets/images/amazon_logo.svg';
import ebayLogoSvg from '../assets/images/ebay_logo.svg'; // NEW IMPORT

// Import the useParallaxZoom hook
import useParallaxZoom from '../hooks/useParallaxZoom';

const WhereToBuySection = ({ amazonUrl, ebayUrl }) => {
    // 1. Use the useParallaxZoom hook for the background effect
    const [parallaxRef, intersectionData] = useParallaxZoom();
    const { intersectionRatio, isAboveViewport, isIntersecting } = intersectionData;

    // State to store the calculated scale for the background
    const [bgScale, setBgScale] = useState(1.15); // Start zoomed in

    // Effect to update the background scale based on scroll position
    useEffect(() => {
        const startZoom = 1.15; 
        const endZoom = 1.0;    

        let newScale;

        if (isIntersecting) {
            newScale = endZoom + (startZoom - endZoom) * (1 - intersectionRatio);
        } else if (isAboveViewport) {
            newScale = endZoom;
        } else {
            newScale = startZoom;
        }

        const clampedScale = Math.max(endZoom, Math.min(startZoom, newScale));
        setBgScale(clampedScale);

    }, [intersectionRatio, isAboveViewport, isIntersecting]); 

    return (
        <section className="where-to-buy-section" ref={parallaxRef}>
            <div
                className="where-to-buy-background-zoom-layer"
                style={{
                    transform: `scale(${bgScale})`,
                    transition: 'transform 0.1s ease-out', 
                }}
            ></div>

            <h2 className="where-to-buy-heading">Where to Buy</h2>

            {/* UPDATED: Store Card with two-column layout */}
            <div className="stores-card">
                
                {/* Column 1: Amazon */}
                <div className="store-column">
                    <img
                        src={amazonLogoSvg}
                        alt="Amazon"
                        className="store-card-main-logo"
                    />
                    <a 
                        href={amazonUrl || ""} 
                        target="_blank" 
                        rel="noopener noreferrer" 
                        className="store-buy-button amazon-buy-button"
                        aria-label="Buy our products on Amazon"
                    >
                        <span className="button-text">Buy on</span> 
                        <img 
                            src={amazonLogoSvg} 
                            alt="Amazon" 
                            className="button-inline-logo" 
                        />    
                    </a>   
                </div>

                {/* Column 2: eBay */}
                <div className="store-column">
                    <img
                        src={ebayLogoSvg}
                        alt="eBay"
                        className="store-card-main-logo"
                    />
                    <a 
                        href={ebayUrl || ""} 
                        target="_blank" 
                        rel="noopener noreferrer" 
                        className="store-buy-button ebay-buy-button"
                        aria-label="Buy our products on eBay"
                    >
                        <span className="button-text">Buy on</span> 
                        <img 
                            src={ebayLogoSvg} 
                            alt="eBay" 
                            className="button-inline-logo" 
                        />    
                    </a>   
                </div>

            </div>
        </section>
    );
};

export default WhereToBuySection;